import { Box, IconButton, ListItem, ListItemText, Switch } from '@mui/material'
import { ArrowDownward, ArrowUpward } from '@mui/icons-material'
import * as React from 'react'
import { useUserContext } from '../../../Contexts/UserConfig'
import { useParams } from 'react-router-dom'

function VisibleListOption({
  option,
  index,
  checked,
  setChecked,
  setSave,
}: {
  option: string
  index: number
  checked: string[]
  setChecked: any
  setSave: any
}) {
  const { loginConfig } = useUserContext()
  const { study_id } = useParams()
  return (
    <ListItem
      key={index}
      sx={{ width: 1, height: 40 }}
    >
      <Switch
        edge="start"
        onChange={() => {
          const currentIndex = checked.indexOf(option)
          const newChecked = [...checked]
          if (currentIndex === -1) {
            newChecked.push(option)
          } else {
            newChecked.splice(currentIndex, 1)
          }
          setChecked(newChecked)
          setSave(true)
        }}
        checked={checked.indexOf(option) !== -1}
        color={'success'}
        disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
      />
      <ListItemText primary={option} />
      {checked.includes(option) && (
        <Box>
          <IconButton
            disabled={
              index === 0 ||
              !loginConfig?.Modules?.EditStudy ||
              study_id === '1'
            }
            onClick={(value) => {
              const currentIndex = checked.indexOf(option)
              const newChecked = [...checked]
              newChecked.splice(currentIndex - 1, 0, option)
              newChecked.splice(currentIndex + 1, 1)
              setChecked(newChecked)
              setSave(true)
            }}
            size={'small'}
          >
            <ArrowUpward />
          </IconButton>
          <IconButton
            disabled={
              index === checked.length - 1 ||
              !loginConfig?.Modules?.EditStudy ||
              study_id === '1'
            }
            onClick={() => {
              const currentIndex = checked.indexOf(option)
              const newChecked = [...checked]
              newChecked.splice(currentIndex + 2, 0, option)
              newChecked.splice(currentIndex, 1)
              setChecked(newChecked)
              setSave(true)
            }}
            size={'small'}
          >
            <ArrowDownward />
          </IconButton>
        </Box>
      )}
    </ListItem>
  )
}

export default VisibleListOption
